import {
  PositionComplianceBucket,
  PositionScreeningStatus,
  RiskRating,
} from "../../../graphql/supergraphEnums";
import {
  PositionComplianceBucket as PositionComplianceBucketType,
  PositionScreeningStatus as PositionScreeningStatusType,
  RiskRating as RiskRatingType,
} from "../../../graphql/supergraphTypes";
import { provideLegalName } from "../../ProfileTree/utils";
import { shouldShowRiskRating } from "../../riskRating/utils";
import { EntityPositionNode } from "../ComplianceDashboardPage/EntityDashboard/types";
import { AmlKycDisplayStatus } from "./types";

export const prepareDataForDisplay = (positions: Array<EntityPositionNode>) => {
  return positions.map((position) => {
    return {
      positionId: position.positionId,
      investorName: provideLegalName(position.investingProfile),
      entityName: position.entityName,
      riskRating: resolveRiskRating(
        position.programId,
        position.riskRating?.positionRiskRating,
      ),
      screeningStatus: mapScreeningStatus(position.screeningStatus),
      complianceStatus: mapAmlKycStatus(
        position.amlKycStatus as PositionComplianceBucketType | null | undefined,
      ),
      onboardingDate: position.onboardingDate ?? null,
      lastActivity: position.lastActivity ?? null,
    };
  });
};

const resolveRiskRating = (
  programId: number | null | undefined,
  rating: RiskRatingType | null | undefined,
): RiskRatingType => {
  if (!shouldShowRiskRating(programId ?? undefined)) return RiskRating.None;
  return rating ?? RiskRating.None;
};

const mapScreeningStatus = (screeningStatus?: PositionScreeningStatusType | null): string => {
  if (screeningStatus == PositionScreeningStatus.IssuesDetected) {
    return "Issue detected";
  } else {
    return "No issues";
  }
};

const mapAmlKycStatus = (
  amlKycStatus?: PositionComplianceBucketType | null,
): AmlKycDisplayStatus => {
  switch (amlKycStatus) {
    case PositionComplianceBucket.Compliant:
      return AmlKycDisplayStatus.Compliant;
    case PositionComplianceBucket.JuniperSquareReview:
      return AmlKycDisplayStatus.InReview;
    case PositionComplianceBucket.LpSubmission:
      return AmlKycDisplayStatus.Submission;
    case PositionComplianceBucket.PendingDivestment:
      return AmlKycDisplayStatus.Divestment;
  }
  return AmlKycDisplayStatus.NotStarted;
};
